export default __webpack_public_path__ + "static/media/pic4.9001ec93.jpg";